/*
  Central API base URL — every request in the app goes through this.

  The value comes from REACT_APP_API_URL, which Create React App inlines at
  BUILD time (not runtime):

    npm start      -> .env.development (the local backend)
    npm run build  -> .env.production  (the Render backend)

  The fallback is insurance for the Bluehost build: if the env file is ever
  missing or the variable is renamed, `API` would be undefined and every
  request would silently go to "undefined/products". Falling back to the live
  Render backend keeps production working, and the warning makes the
  misconfiguration visible instead of silent.

  Note this is the API base only. Image URLs are stored complete in MongoDB
  (https://poojamart-backend.onrender.com/uploads/<filename>) and are used
  exactly as the backend returns them — the frontend never builds them.
*/

const FALLBACK_API = 'https://poojamart-backend.onrender.com/api';

const configured = (process.env.REACT_APP_API_URL || '').trim();

if (!configured) {
  console.warn(
    `REACT_APP_API_URL is not set — falling back to ${FALLBACK_API}. ` +
      'Check .env.production before deploying.'
  );
}

/* A trailing slash would turn `${API}/products` into "…/api//products". */
const stripTrailingSlash = (url) => {
  let trimmed = url;

  while (trimmed.endsWith('/')) {
    trimmed = trimmed.slice(0, -1);
  }

  return trimmed;
};

const API = stripTrailingSlash(configured || FALLBACK_API);

export default API;
